import React, { useEffect, useState } from 'react';
import './Article.scss';
import RatingGroup from '../RatingGroup/RatingGroup';
import { Link } from 'react-router-dom';
import { isEmpty } from 'lodash';
import i18next from 'i18next';
import { fromEnglish } from '../../translation';
import { IArticle, SearchService } from '../../services/search.service';
import { useService } from 'react-service-locator';
import { Immutable } from 'react-service-locator/dist/types/immutable';

const Article: React.FC<{ article: Immutable<IArticle> }> = ({ article }) => {
    const [ln, setLn] = useState(i18next.resolvedLanguage);
    const [title, setTitle] = useState<string>(article.title);
    const [keywords, setKeywords] = useState<string[]>([]);

    useEffect(() => {
        const handler = (language: string) => setLn(language);
        i18next.on('languageChanged', handler);
        return () => i18next.off('languageChanged', handler);
    }, []);

    useEffect(() => {
        let cancelled = false;

        (async () => {
            const translatedTitle = await fromEnglish(article.title);

            const translatedKeywords = await Promise.all(
                (article.keywords ?? [])
                    .map((c) => c.trim())
                    .filter((d) => !isEmpty(d))
                    .map((e) => fromEnglish(e ?? '')),
            );

            if (!cancelled) {
                setTitle(translatedTitle);
                setKeywords(translatedKeywords.map((e) => e.toLowerCase()));
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [ln, article.pmid]); // simplest + stable

    return (
        <Link className="link-unstyled article-row" to={'/results/' + article.pmid}>
            <div>
                <h3>{title}</h3>
                <div className="keywords">
                    {keywords.slice(0, 5).map((c, i) => (
                        <span key={'keyword-' + article.pmid + '-' + i} className="body body-normal">
                            {c.charAt(0).toUpperCase() + c.slice(1)}
                        </span>
                    ))}
                </div>
                <br />
                {article.researchPopulation && (
                    <span className="research">Onderzoekspopulatie: {article.researchPopulation}</span>
                )}
            </div>
            <RatingGroup article={article} />
        </Link>
    );
};

export default Article;
